export const iconFontAwesomeShoppingCartShopping = (
	<i className="fa-solid fa-cart-shopping"></i>
);
